import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export default gql`
query claimsLookup(
	$skip: Int
	$take: Int
	$where: ClaimsLookupFilterInput
	$order: [ClaimsLookupSortInput!]
) {
	claimsLookup(
	skip: $skip
	take: $take
	where: $where
	order: $order
)    {
      pageInfo{
        hasNextPage,
        hasPreviousPage
      },

        items {
        	claim { swAfgehandeld, id, schadenr, cedSchadenr, aanmelddatum, behandelaar, datum, letselschade}
        	brancheGroup { omschrijving }
        	brancheSpec { omschrijving }
        	company { naam }
            customer {
                id, naam, postcode, plaats, emailadres
            },
            broker { id, naam}
            policy {
            	id, kenteken, polnr, policyId, relnr
            }
        }
    }
}`;
